import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || '/dashboard/login';

const Header = () => {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const links = [
    { label: t('nav.demo'),       href: '#demo' },
    { label: t('nav.howItWorks'), href: '#how-it-works' },
    { label: t('nav.features'),   href: '#features' },
    { label: t('nav.contact'),    href: '#contact' },
  ];

  const scrollTo = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
      <header
          className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
              scrolled
                  ? 'bg-white shadow-sm shadow-black/5 border-b border-gray-100'
                  : 'bg-transparent'
          }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">

          {/* Logo */}
          <a href="/" className="flex items-center gap-2 shrink-0">
            <span className={`text-lg font-bold tracking-tight transition-colors ${
                scrolled ? 'text-gray-900' : 'text-white'
            }`}>
              3dp<span className="text-emerald-500">.</span>
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-7">
            {links.map(({ label, href }) => (
                <a
                key={href}
              href={href}
              onClick={(e) => scrollTo(e, href)}
              className={`text-sm font-medium transition-colors ${
              scrolled
              ? 'text-gray-500 hover:text-gray-900'
              : 'text-white/70 hover:text-white'
            }`}
              >
            {label}
              </a>
              ))}
          </nav>

          {/* Desktop actions */}
          <div className="hidden md:flex items-center gap-4">
            <a
            href={LOGIN_URL}
            className={`text-sm font-medium transition-colors ${
              scrolled ? 'text-gray-500 hover:text-gray-900' : 'text-white/60 hover:text-white'
          }`}
            >
            {t('nav.login')}
          </a>
          <a
          href="#contact"
          onClick={(e) => scrollTo(e, '#contact')}
          className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-semibold
          rounded-lg transition-colors shadow-sm"
          >
          {t('nav.bookDemo')}
        </a>
      </div>

  {/* Mobile burger */}
  <button
      className={`md:hidden p-2 rounded-lg transition-colors ${
          scrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
      }`}
      onClick={() => setMenuOpen((v) => !v)}
      aria-label="Меню"
  >
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      {menuOpen
          ? <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          : <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      }
    </svg>
  </button>
</div>

  {/* Mobile menu */}
  {menuOpen && (
      <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
        <div className="px-4 py-3 flex flex-col gap-0.5">
          {links.map(({ label, href }) => (
              <a
              key={href}
            href={href}
            onClick={(e) => scrollTo(e, href)}
            className="px-3 py-2.5 text-sm font-medium text-gray-600 hover:text-emerald-600
            hover:bg-gray-50 rounded-lg transition-colors"
            >
          {label}
            </a>
            ))}
        </div>
        <div className="px-4 py-3 border-t border-gray-100 flex items-center justify-between">
          <a
          href={LOGIN_URL}
          className="text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
          >
          {t('nav.login')}
        </a>
      <a
        href="#contact"
        onClick={(e) => scrollTo(e, '#contact')}
        className="px-4 py-2 bg-emerald-600 text-white text-sm font-semibold rounded-lg
        hover:bg-emerald-500 transition-colors"
        >
        {t('nav.bookDemo')}
      </a>
  </div>
  </div>
  )}
</header>
);
};

export default Header;
